import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import TextMobileStepper from './Info';
import { Button } from '@mui/material';
import FAQs from './FAQs';
import { DemoVideoScreen } from './DemoVideoScreen';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0}}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export const GettingStarted = (props) => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', position:'absolute', top:0, left: 0}}>
        <Button onClick={props.CloseBtn} sx={{position:'absolute', top:8,right:18, zIndex:10000001}} variant='button'>Close</Button>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs sx={{fontWeight:'bold', color:'white'}} value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Quick Start Guide" {...a11yProps(0)} />
          {/* <Tab label="FAQs" {...a11yProps(1)} /> */}
          <Tab label="Demo Video" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
       <TextMobileStepper/>
      </TabPanel>
       <TabPanel  value={value} index={1}>
        <DemoVideoScreen/>
      </TabPanel> 
      
    
    </Box>
  );
}